export enum Application {
    BookingEngine = 'BookingEngine',
    Commander = 'Commander',
    DeviceHub = 'DeviceHub',
    EMSQuotation = 'EMSQuotation',
    GuestPortal = 'GuestPortal',
    Kiosk = 'Kiosk',
    Platform = 'Platform',
}
